var _defs, _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgAboutHero(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 523.531,
    height: 368.148,
    viewBox: "0 0 523.531 368.148",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient",
    y1: 0.5,
    x2: 1,
    y2: 0.5,
    gradientUnits: "objectBoundingBox"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#f46262"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#ff725e"
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "about-hero",
    transform: "translate(-27.838 -26.965)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_5920",
    "data-name": "Group 5920"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_4780",
    "data-name": "Path 4780",
    d: "M507.071,58.628a34.656,34.656,0,0,0-3.7-8.929l3.77-5.67-5.231-5.23-5.23-5.231-5.67,3.77a34.671,34.671,0,0,0-8.929-3.7l-1.342-6.669H465.941L464.6,33.634a34.671,34.671,0,0,0-8.929,3.7L450,33.568l-5.23,5.231-5.231,5.23,3.77,5.67a34.618,34.618,0,0,0-3.7,8.929l-6.67,1.342V74.764l6.67,1.343a34.647,34.647,0,0,0,3.7,8.929l-3.77,5.67,5.231,5.23,5.23,5.231,5.67-3.77a34.633,34.633,0,0,0,8.929,3.7l1.343,6.67h14.794l1.342-6.67a34.633,34.633,0,0,0,8.929-3.7l5.67,3.77,5.23-5.231,5.231-5.23-3.77-5.67a34.686,34.686,0,0,0,3.7-8.929l6.669-1.343V59.97ZM473.337,93.287a25.92,25.92,0,1,1,25.92-25.92A25.92,25.92,0,0,1,473.337,93.287Z",
    fill: "#ff725e"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_5921",
    "data-name": "Group 5921"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_4781",
    "data-name": "Path 4781",
    d: "M517.162,121.534a15.871,15.871,0,0,0-1.7-4.093l1.73-2.6-2.4-2.4-2.4-2.4-2.6,1.728a15.879,15.879,0,0,0-4.094-1.7l-.615-3.057h-6.782l-.616,3.057a15.886,15.886,0,0,0-4.093,1.7l-2.6-1.728-2.4,2.4-2.4,2.4,1.729,2.6a15.906,15.906,0,0,0-1.7,4.093l-3.057.616v6.782l3.057.616a15.921,15.921,0,0,0,1.7,4.093l-1.729,2.6,2.4,2.4,2.4,2.4,2.6-1.728a15.886,15.886,0,0,0,4.093,1.7l.616,3.057h6.782l.615-3.057a15.878,15.878,0,0,0,4.094-1.7l2.6,1.728,2.4-2.4,2.4-2.4-1.73-2.6a15.885,15.885,0,0,0,1.7-4.093l3.058-.616V122.15ZM501.7,137.424a11.883,11.883,0,1,1,11.883-11.883A11.883,11.883,0,0,1,501.7,137.424Z",
    fill: "#ff725e"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_5922",
    "data-name": "Group 5922"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_317",
    "data-name": "Rectangle 317",
    width: 36.389,
    height: 110.526,
    transform: "translate(338.613 357.197) rotate(180)",
    fill: "#fc3622"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_5923",
    "data-name": "Group 5923"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_318",
    "data-name": "Rectangle 318",
    width: 314.22,
    height: 221.666,
    rx: 15.981,
    transform: "translate(477.528 299.912) rotate(180)",
    fill: "#ff725e"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_5924",
    "data-name": "Group 5924"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_319",
    "data-name": "Rectangle 319",
    width: 289.608,
    height: 210.521,
    transform: "translate(465.222 265.175) rotate(180)",
    fill: "#fff"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_5925",
    "data-name": "Group 5925"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_320",
    "data-name": "Rectangle 320",
    width: 289.608,
    height: 25.427,
    transform: "translate(465.222 80.081) rotate(180)",
    fill: "url(#linear-gradient)"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_5926",
    "data-name": "Group 5926"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_4782",
    "data-name": "Path 4782",
    d: "M310.282,281.071a10.135,10.135,0,1,0,10.136-10.136A10.136,10.136,0,0,0,310.282,281.071Z",
    fill: "#fc3622"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_5929",
    "data-name": "Group 5929"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_5928",
    "data-name": "Group 5928"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_5927",
    "data-name": "Group 5927"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Rectangle_321",
    "data-name": "Rectangle 321",
    d: "M3.517,0h86.5a3.518,3.518,0,0,1,3.518,3.518v.5a3.517,3.517,0,0,1-3.517,3.517H3.517A3.517,3.517,0,0,1,0,4.017v-.5A3.517,3.517,0,0,1,3.517,0Z",
    transform: "translate(363.38 105.7) rotate(180)",
    fill: "#dfe1e8"
  })))), /*#__PURE__*/React.createElement("g", {
    id: "Group_5932",
    "data-name": "Group 5932"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_5931",
    "data-name": "Group 5931"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_5930",
    "data-name": "Group 5930"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Rectangle_322",
    "data-name": "Rectangle 322",
    d: "M3.518,0h86.5a3.518,3.518,0,0,1,3.518,3.518v.5a3.517,3.517,0,0,1-3.517,3.517H3.517A3.517,3.517,0,0,1,0,4.018v-.5A3.518,3.518,0,0,1,3.518,0Z",
    transform: "translate(363.38 119.29) rotate(180)",
    fill: "#dfe1e8"
  })))), /*#__PURE__*/React.createElement("g", {
    id: "Group_5935",
    "data-name": "Group 5935"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_5934",
    "data-name": "Group 5934"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_5933",
    "data-name": "Group 5933"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Rectangle_323",
    "data-name": "Rectangle 323",
    d: "M3.517,0h86.5a3.518,3.518,0,0,1,3.518,3.518v.5a3.518,3.518,0,0,1-3.518,3.518H3.517A3.517,3.517,0,0,1,0,4.018v-.5A3.517,3.517,0,0,1,3.517,0Z",
    transform: "translate(363.38 132.879) rotate(180)",
    fill: "#dfe1e8"
  })))), /*#__PURE__*/React.createElement("g", {
    id: "Group_5939",
    "data-name": "Group 5939"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_5938",
    "data-name": "Group 5938"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_5937",
    "data-name": "Group 5937"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_5936",
    "data-name": "Group 5936"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_4783",
    "data-name": "Path 4783",
    d: "M314,250.363H205.439a16.436,16.436,0,0,1-16.417-16.417V167.91a16.436,16.436,0,0,1,16.417-16.417H314a16.435,16.435,0,0,1,16.416,16.417v66.036A16.435,16.435,0,0,1,314,250.363ZM205.439,153.551A14.375,14.375,0,0,0,191.08,167.91v66.036A14.375,14.375,0,0,0,205.439,248.3H314a14.376,14.376,0,0,0,14.359-14.359V167.91A14.375,14.375,0,0,0,314,153.551Z",
    fill: "#dfe1e8"
  }))))), /*#__PURE__*/React.createElement("g", {
    id: "Group_5942",
    "data-name": "Group 5942"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_5941",
    "data-name": "Group 5941"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_5940",
    "data-name": "Group 5940"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_324",
    "data-name": "Rectangle 324",
    width: 105.886,
    height: 15.88,
    rx: 7.25,
    transform: "translate(312.661 176.381) rotate(180)",
    fill: "#dfe1e8"
  })))), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_325",
    "data-name": "Rectangle 325",
    width: 163.71,
    height: 8.344,
    transform: "translate(238.563 353.026)",
    fill: "#ff725e"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group_5951",
    "data-name": "Group 5951"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_4784",
    "data-name": "Path 4784",
    d: "M432.653,173.19a23.573,23.573,0,0,1-16.139,22.37c-.141.048-.283.094-.426.137a23.568,23.568,0,1,1,16.565-22.507Z",
    fill: "#eef0f7"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group_5943",
    "data-name": "Group 5943"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_4785",
    "data-name": "Path 4785",
    d: "M403.458,170.7s-1.609-10.412,7.015-10.22,8.509,5.341,8.354,10.451-3.458,4.726.27,11.834-3.228,7.109-3.228,7.109l-5.4-7.416Z",
    fill: "#3c4145"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_5944",
    "data-name": "Group 5944"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_4786",
    "data-name": "Path 4786",
    d: "M409.53,161.481s-5.841.922-6.072,9.221,1.576,10.067,6.686,8.338,6.724-10.412,6.84-11.757S417.406,160.482,409.53,161.481Z",
    fill: "#eea886"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_5945",
    "data-name": "Group 5945"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_4787",
    "data-name": "Path 4787",
    d: "M419.785,190.348a5.646,5.646,0,0,1-3.271,5.212c-.141.048-.283.094-.426.137a23.656,23.656,0,0,1-17.474-1.392c-.711-1.418.318-3.429,2.408-6.518,1.434-2.122,2.843-4.288,5.25-5.341,3.551-.566,7.312-.6,9.961.9C418.344,184.536,419.751,186.7,419.785,190.348Z",
    fill: "#e55353"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_5946",
    "data-name": "Group 5946"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_4788",
    "data-name": "Path 4788",
    d: "M402.165,187.662l-2.684,4.232c.006-.023.184-.663.488-2.519.058-.352.12-.748.187-1.192a2.607,2.607,0,0,1,.084-.39h0c1.149-2.65,4.733-4.62,4.863-4.686Z",
    fill: "#e55353"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_5947",
    "data-name": "Group 5947"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_4789",
    "data-name": "Path 4789",
    d: "M420.983,193.537a23.563,23.563,0,0,1-4.469,2.023c-.141.048-.283.094-.426.137-.6-1.537-1.112-2.868-1.224-3.212-.033-.1-.11-.287-.214-.539a17.83,17.83,0,0,1-1.581-5.841c-.009-1.32.426-2.4,1.754-2.71a3.463,3.463,0,0,1,1.41-.052,4.139,4.139,0,0,1,2.831,2.782c.009.02.015.04.022.059a9.062,9.062,0,0,1,.529,1.883l.067.259c.083.33.242.955.449,1.775C420.367,191.041,420.665,192.237,420.983,193.537Z",
    fill: "#eea886"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_5948",
    "data-name": "Group 5948"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_4790",
    "data-name": "Path 4790",
    d: "M413.43,175.3c-.507.956-1.041,6.891-1.041,6.891s-7.144,2.7-6.412,1.172a5.836,5.836,0,0,0,.435-2.368,11.43,11.43,0,0,0-.079-1.441c-.018-.156-.033-.246-.033-.246S413.936,174.346,413.43,175.3Z",
    fill: "#eea886"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_5949",
    "data-name": "Group 5949"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_4791",
    "data-name": "Path 4791",
    d: "M407.148,167.437s3,4.879,5.724,6.8,1.345,3.458,1.345,3.458,7.118-14.986.351-16.023-10.917-1.114-11.11,9.029C403.458,170.7,406.532,167.36,407.148,167.437Z",
    fill: "#3c4145"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_5950",
    "data-name": "Group 5950"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_4792",
    "data-name": "Path 4792",
    d: "M410.406,178.945c-1.1,1.617-3.993,2.052-3.993,2.052h0a11.43,11.43,0,0,0-.079-1.441A8.168,8.168,0,0,0,410.406,178.945Z",
    fill: "#a77860"
  })), /*#__PURE__*/React.createElement("path", {
    id: "Path_4793",
    "data-name": "Path 4793",
    d: "M400.252,187.761h0a5.992,5.992,0,0,0-.282,1.614l1.052-1.588s1.879-2.694,2.523-3.4a9.974,9.974,0,0,1,1.576-1.316S401.375,184.855,400.252,187.761Z",
    fill: "#bd4444"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_4794",
    "data-name": "Path 4794",
    d: "M414.466,191.779a40.251,40.251,0,0,1,5.941-1.9s-.921-7.363-5.425-6.582S414.466,191.779,414.466,191.779Z",
    fill: "#e55353"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_4795",
    "data-name": "Path 4795",
    d: "M406.272,182.446s-3.366,5.175-2.227,5.627,7.307-.6,9.93-5.519C413.975,182.554,410.054,180.543,406.272,182.446Z",
    fill: "#eea886"
  })), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_326",
    "data-name": "Rectangle 326",
    width: 36.722,
    height: 3.363,
    transform: "matrix(1, -0.008, 0.008, 1, 121.651, 296.462)",
    fill: "#1f3138"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_327",
    "data-name": "Rectangle 327",
    width: 36.722,
    height: 3.363,
    transform: "translate(155.194 298.564) rotate(-72.995)",
    fill: "#1f3138"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group_5952",
    "data-name": "Group 5952"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_328",
    "data-name": "Rectangle 328",
    width: 2.865,
    height: 88.279,
    transform: "translate(221.517 303.934)",
    fill: "#706865"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_5953",
    "data-name": "Group 5953"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_329",
    "data-name": "Rectangle 329",
    width: 125.939,
    height: 5.019,
    transform: "translate(239.954 303.934) rotate(180)",
    fill: "#b59074"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_5954",
    "data-name": "Group 5954"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_330",
    "data-name": "Rectangle 330",
    width: 2.865,
    height: 88.281,
    transform: "translate(132.993 392.215) rotate(180)",
    fill: "#706865"
  })), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_331",
    "data-name": "Rectangle 331",
    width: 3.445,
    height: 43.479,
    transform: "translate(72.563 334.249)",
    fill: "#918783"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_4796",
    "data-name": "Path 4796",
    d: "M117.524,372.6a18.526,18.526,0,0,0,.657,4.16c.457,1.641,1.376,8,2.549,8.885s4.955,3.244,4.4,5.664-1.026,4.108-5.11,2.675-6.815-2.253-7.6-5.838a22.5,22.5,0,0,0-3.02-6.848l-2.952,7.343-1.557-.627s2.354-7.931,2.152-8.638,1.079-7.009,6.019-8.569S117.524,372.6,117.524,372.6Z",
    fill: "#1d3b54"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_4797",
    "data-name": "Path 4797",
    d: "M144.8,374.916a18.524,18.524,0,0,0,2.162,3.613c1.037,1.353,4.259,6.906,5.679,7.292s5.808,1.163,6.2,3.615.58,4.2-3.744,4.388-7.163.452-9.228-2.582a22.465,22.465,0,0,0-5.356-5.226v7.913h-1.678s-.774-8.235-1.226-8.816S136,378.207,140,374.916,144.8,374.916,144.8,374.916Z",
    fill: "#1d3b54"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_4798",
    "data-name": "Path 4798",
    d: "M100.841,267.379s.961-3.408,1.055-3.853a7.147,7.147,0,0,1,2.135-2.248,8.29,8.29,0,0,1,3.316-1.587,1.278,1.278,0,0,1,.915.548,2.458,2.458,0,0,1,.452,1.161,1.493,1.493,0,0,1,.791,1.205,1.3,1.3,0,0,1,.579,1.325s.693.42.534,1.076a9.934,9.934,0,0,0-1.152,1.311,20.792,20.792,0,0,1-4.451,3.483S102.22,271.863,100.841,267.379Z",
    fill: "#eea886"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_4799",
    "data-name": "Path 4799",
    d: "M105.023,264.678a7.332,7.332,0,0,1,.327,1.9c-.088.461,3.276.529,3.276.529S106.78,264.222,105.023,264.678Z",
    fill: "#cf8c6c"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_4800",
    "data-name": "Path 4800",
    d: "M67.153,273.238c1.358-2.2,3.17-3.189,8.924.791s4.4,3.2,5.781,4.462,7.416,4.417,7.416,4.417a53.868,53.868,0,0,0,5.218-6c1.907-2.806,5.887-10.306,5.887-10.306l5.581,4.154s-10.842,19.655-13.106,21.108-9.087-.977-12.639-2.473-7.312-3.434-8.934-3.836S63.61,278.975,67.153,273.238Z",
    fill: "#1d3b54"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_332",
    "data-name": "Rectangle 332",
    width: 12.612,
    height: 1.067,
    transform: "matrix(0.214, -0.977, 0.977, 0.214, 105.326, 262.712)",
    fill: "#eb4747"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_4801",
    "data-name": "Path 4801",
    d: "M107.041,259.921s-2.813,2.408-2.481,2.909a.945.945,0,0,0,.758.484l-.709,1.516s.1,1.269,1.451.791c0,0-.031,1.2,1.221.578,0,0,.331.8.961.615a12.345,12.345,0,0,0,2.376-1.808s.214-.508-.534-1.076a1.277,1.277,0,0,0-.579-1.325,1.406,1.406,0,0,0-.791-1.205s-.034-1.613-1.367-1.709C107.347,259.691,107.159,259.819,107.041,259.921Z",
    fill: "#db9c7c"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_4802",
    "data-name": "Path 4802",
    d: "M101.935,263.563a12.617,12.617,0,0,1,3.322-2.184c.325-.108.66-.154.883.108s.129.916-.65,1.7a9.314,9.314,0,0,0-1.428,2.144S103.027,265.895,101.935,263.563Z",
    fill: "#eea886"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_4803",
    "data-name": "Path 4803",
    d: "M93.979,285.177s1.133-4.106-.2-7.286a9.526,9.526,0,0,1-.933,5.631C91.8,285.218,93.979,285.177,93.979,285.177Z",
    fill: "#263238"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_4804",
    "data-name": "Path 4804",
    d: "M114.539,285.813s3.037-22.51,8.334-32.325h-7.789s-8.724,15.373-7.088,30.9Z",
    fill: "#eddad3"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_4805",
    "data-name": "Path 4805",
    d: "M116.4,268.961s.888-1.656,1.1-2.2,1.087.4.956,1.092S116.4,268.961,116.4,268.961Z",
    fill: "#eea886"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_4806",
    "data-name": "Path 4806",
    d: "M123.311,272.725a3.873,3.873,0,0,1-.511,1.116s-.544.515-.909.9a3.551,3.551,0,0,0-.268.313A7.051,7.051,0,0,1,120.2,276.8c-.777.626-3.748,2.559-3.748,2.559l-2.1-2.24-1.678-1.745s1.418-5.33,2.076-6a2.3,2.3,0,0,1,.2-.179,8.931,8.931,0,0,1,1.632-.866c.13-.085,1.474-.836,1.9-.67a1.5,1.5,0,0,1,1.007,1.06,3.6,3.6,0,0,1,1.529,1.253,2.237,2.237,0,0,1,1.283,1.5S123.342,272.028,123.311,272.725Z",
    fill: "#eea886"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_4807",
    "data-name": "Path 4807",
    d: "M137.1,330.853,128.28,350.7c-.617,1.392-1.194,2.688-1.7,3.819-.589,1.326-1.078,2.424-1.414,3.182-2.339,5.261-8.091,16.733-8.091,16.733s-4.327.165-4.578-3.51c0,0,4.152-7.962,4.152-13.557s.751-22.076,6.1-25.638C129.266,327.381,133.5,326.558,137.1,330.853Z",
    fill: "#eea886"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_4808",
    "data-name": "Path 4808",
    d: "M89.51,308.843a5.979,5.979,0,0,0,2,1.336c.919.251,16.285,1.421,23.384,3.759s16.535,3.841,18.288,5.845,4.677,13.028,4.594,15.116,6.238,37.271,7.025,40.017c.418,1.455-5.717.9-5.717.9s-8.717-20.79-10.578-24.631c-3.421-7.057-3.591-15.7-4.844-17.037s-15.2-4.342-23.216-4.342-25.972.668-27.893-.418-13.946-9.02-8.935-19.625S89.51,308.843,89.51,308.843Z",
    fill: "#eea886"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_4809",
    "data-name": "Path 4809",
    d: "M124.189,316.438l-12.72,24.474s-3.831-9.082-10.515-10.645-33.36-.725-33.36-.725-12.241-15.484-1.758-23.607,22.723,1.278,22.723,1.278,2.53,2.741,3.753,2.8C101.206,310.458,110.691,312.114,124.189,316.438Z",
    fill: "#1d3b54"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_4810",
    "data-name": "Path 4810",
    d: "M152.646,385.821s-3.872.969-5.356,0-6.53-9.5-8.2-10.006c0,0,1.62-3.286,5.717-.9C144.8,374.916,151.549,384.4,152.646,385.821Z",
    fill: "#eea886"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_4811",
    "data-name": "Path 4811",
    d: "M120.73,385.645s-3.954-.547-4.97-2-2.516-11.247-3.876-12.345c0,0,2.728-2.445,5.64,1.3C117.524,372.6,120.241,383.917,120.73,385.645Z",
    fill: "#eea886"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_4812",
    "data-name": "Path 4812",
    d: "M80.332,231.981a10.348,10.348,0,0,1,10.875,9.484,25.18,25.18,0,0,1-.774,3.9c-.53,1.713,1.007,6.77.606,7.02a11.193,11.193,0,0,1-2.058.567s-1.782,5.524-3.721,5.477-9.28-1.564-12.738-8.436S68,232.577,80.332,231.981Z",
    fill: "#eea886"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_4813",
    "data-name": "Path 4813",
    d: "M82.64,255.907s-.238.775-.509,1.923c-.139.588-.286,1.272-.414,2a13.62,13.62,0,0,0-.036,5.94s-4.287,1.485-7.674-4.574c0,0,1.454-6.528-.436-10.487S82.64,255.907,82.64,255.907Z",
    fill: "#eea886"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_4814",
    "data-name": "Path 4814",
    d: "M91.207,241.465s-4.687,4.207-9.644,3.874c-5.035-.339-8.3,5.952-8.3,5.952s-7.494-9.4-1.453-17.008S92.278,232.029,91.207,241.465Z",
    fill: "#1d3b54"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_4815",
    "data-name": "Path 4815",
    d: "M79.28,245.3a1.515,1.515,0,0,0-2.648-1.081c-1.561,1.3.538,5.832,1.817,5.389S79.308,246.286,79.28,245.3Z",
    fill: "#eea886"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_4816",
    "data-name": "Path 4816",
    d: "M82.131,257.83c-.139.588-.286,1.272-.414,2a21.266,21.266,0,0,1-5.985-5.6A24.174,24.174,0,0,0,82.131,257.83Z",
    fill: "#a77860"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_4817",
    "data-name": "Path 4817",
    d: "M93.753,280.988c-.9,4.182-3.277,4.4-3.133,7.491s1.066,3.354-.531,8.225a23.952,23.952,0,0,0-.73,2.886c-.022.118-.046.237-.066.356-.1.563-.193,1.129-.27,1.688-.142,1.034-.245,2.044-.316,2.966a6.153,6.153,0,0,0,1.582,4.26s-15.631,9.365-26.362,8.05c0,0,2.778-11.677,4.308-15.689s1.068-22.547-.058-26.525c-1.661-5.87,1.658-14.67,6.195-15.817l7.035,3.258s7.086,8.463,8.676,9.74S94.669,276.746,93.753,280.988Z",
    fill: "#1d3b54"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_4818",
    "data-name": "Path 4818",
    d: "M70.5,263.852c1.987-1.655,4.862-4.487,9.055,1.115s7.245,9.211,8.151,10.845,8.789,13.013,8.789,13.013,4.187-3.887,6.582-5.712c2.7-2.056,10.055-9.72,10.055-9.72l4.862,5.39S101.127,297.5,98.518,298.158s-9.913-5.913-12.806-8.461-11.01-11.822-12.42-12.719S65.319,268.166,70.5,263.852Z",
    fill: "#1d3b54"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_4819",
    "data-name": "Path 4819",
    d: "M128.28,350.7c-.617,1.392-1.194,2.688-1.7,3.819-1.893-6.087-1.737-16.259-1.737-16.259A57.715,57.715,0,0,0,128.28,350.7Z",
    fill: "#a77860"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_333",
    "data-name": "Rectangle 333",
    width: 54.176,
    height: 5.962,
    transform: "translate(46.778 329.542)",
    fill: "#ff725e"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_4820",
    "data-name": "Path 4820",
    d: "M74.969,310.526s-1.366,5.523,5.064,6.778,14.34,2.857,14.34,12.778H72.07Z",
    fill: "#ff725e"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_4821",
    "data-name": "Path 4821",
    d: "M108.034,250.395l.92-1.7.122,1.927Z",
    fill: "#eea886"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_4822",
    "data-name": "Path 4822",
    d: "M46.778,335.5l-18.94-79.6s34.24-5.35,38.319,10.026,10.791,61.05,18.95,63.874S46.778,335.5,46.778,335.5Z",
    fill: "#ff725e"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_4823",
    "data-name": "Path 4823",
    d: "M90.819,294.046s-.349,1.461-.722,2.67l-8.33-10.8Z",
    fill: "#263238"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_4824",
    "data-name": "Path 4824",
    d: "M69.935,244.531s3.293,8.7,2.4,11.077a7.34,7.34,0,0,0,4.2-7.9C75.6,242.013,69.935,244.531,69.935,244.531Z",
    fill: "#1d3b54"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_4825",
    "data-name": "Path 4825",
    d: "M81.813,262.62V260.9l-7.31-3.56-2.529,2.921Z",
    fill: "#1d3b54"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_4826",
    "data-name": "Path 4826",
    d: "M107.724,388.952a2.832,2.832,0,1,1-2.832-2.832A2.831,2.831,0,0,1,107.724,388.952Z",
    fill: "#bfb2ac"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_4827",
    "data-name": "Path 4827",
    d: "M43.946,386.146l.717,2.018,30.306-9.39-1.453-4.086Z",
    fill: "#918783"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_4828",
    "data-name": "Path 4828",
    d: "M104.892,386.146l-.717,2.018-30.306-9.39,1.332-4.342Z",
    fill: "#918783"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_4829",
    "data-name": "Path 4829",
    d: "M83.54,387.947V390.3l-9.67-11.522,1.332-4.342Z",
    fill: "#918783"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_4830",
    "data-name": "Path 4830",
    d: "M83.781,388.952a2.833,2.833,0,1,1-2.833-2.832A2.832,2.832,0,0,1,83.781,388.952Z",
    fill: "#bfb2ac"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_1050",
    "data-name": "Ellipse 1050",
    cx: 2.832,
    cy: 2.832,
    r: 2.832,
    transform: "translate(41.114 386.12)",
    fill: "#bfb2ac"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group_5964",
    "data-name": "Group 5964"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_4831",
    "data-name": "Path 4831",
    d: "M441.357,104.44a30.539,30.539,0,0,1-7.185,19.725,30.888,30.888,0,0,1-3.427,3.474c-.351.3-.711.6-1.076.888q-.619.489-1.263.947a30.485,30.485,0,0,1-13.945,5.4q-1.361.17-2.759.214c-.334.011-.67.016-1.006.016q-1.49,0-2.941-.139a30.638,30.638,0,0,1-18.819-8.921c-.189-.19-.375-.383-.558-.577a29.713,29.713,0,0,1-1.946-2.278,30.662,30.662,0,1,1,54.925-18.747Z",
    fill: "#eef0f7"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group_5963",
    "data-name": "Group 5963"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_5955",
    "data-name": "Group 5955"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_4832",
    "data-name": "Path 4832",
    d: "M430.668,121.359l-2.262,8.115a30.485,30.485,0,0,1-13.945,5.4q-1.361.17-2.759.214c-.334.011-.67.016-1.006.016q-1.49,0-2.941-.139a30.544,30.544,0,0,1-15.724-6.195c-.433-2.683-.9-5.652-1.309-8.429,2.254-.839,9.427-3.278,13.953-4.809l.189-.063c.1-.035.2-.068.293-.1l.769-.259c.248-.084.484-.163.7-.24l1.815-.609h0l.092-.032.053,0,6.087.456,1.02.076.319.024.138.035c.368.093,1.434.373,2.846.8l.007,0C422.615,116.728,428.463,118.823,430.668,121.359Z",
    fill: "#f9e8de"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_5956",
    "data-name": "Group 5956"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_4833",
    "data-name": "Path 4833",
    d: "M412.291,89.215s7.3,1.231,6.062,12.66-7.681,10.421-8.113,10.4-6.481.139-6.8-13.835C403.44,98.444,403.347,88.112,412.291,89.215Z",
    fill: "#eea987"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_5957",
    "data-name": "Group 5957"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_4834",
    "data-name": "Path 4834",
    d: "M415.49,108.967s-.251,4.7.192,5.727-5.861,4.263-9.779.573c0,0,.792-5.141.545-6.957S415.49,108.967,415.49,108.967Z",
    fill: "#eea987"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_5958",
    "data-name": "Group 5958"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_4835",
    "data-name": "Path 4835",
    d: "M418.5,98.645s.81-.847,1.094.022-1.294,4.721-1.2,4.9c0,0-.15.334-.34.147A41.736,41.736,0,0,1,418.5,98.645Z",
    fill: "#eea987"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_5959",
    "data-name": "Group 5959"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_4836",
    "data-name": "Path 4836",
    d: "M403.524,98.337s-.776-.88-1.1-.023.848,4.7.993,4.941c0,0,.251.4.449.216A42.121,42.121,0,0,0,403.524,98.337Z",
    fill: "#eea987"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_5960",
    "data-name": "Group 5960"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_4837",
    "data-name": "Path 4837",
    d: "M418.969,97.674c-.253,1.564-.489,2.726-.489,2.726l-1.063,1.387a28.037,28.037,0,0,0-.1-3.55c-.062-.183-.134-.506-.208-.856-.123-.579-.247-1.231-.333-1.448-.137-.348-6.257-2.135-11.708.374,0,0,.046.472.043,1,0,.612-.069,1.3-.35,1.4-.522.191-.3,3.59-.3,3.59l-.849-.98s-.246-1.776-.488-3.817l0-.015c-.054-.476-.111-.965-.164-1.451-.122-2.053.081-5.781,2.755-7.971,1.8-.772,4.684-1.428,9.485.042a3.308,3.308,0,0,1,1.41.37C419.594,91.767,418.969,97.674,418.969,97.674Z",
    fill: "#ff725e"
  })), /*#__PURE__*/React.createElement("path", {
    id: "Path_4838",
    "data-name": "Path 4838",
    d: "M406.949,110.752a4.652,4.652,0,0,0,3.873,1.557,5.267,5.267,0,0,0,3.881-1.473s-1.281,2.681-3.894,2.652S406.949,110.752,406.949,110.752Z",
    fill: "#c78d71"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_4839",
    "data-name": "Path 4839",
    d: "M405.158,115.366a7.953,7.953,0,0,0,5.668,3.727c2.356.2,4.394-2.781,5.349-4.246A14.262,14.262,0,0,0,405.158,115.366Z",
    fill: "#eea987"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_4840",
    "data-name": "Path 4840",
    d: "M415.5,113.77a20.241,20.241,0,0,1-4.672,4.047l1.978,3.046,3.371-6.016Z",
    fill: "#eddad3"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_4841",
    "data-name": "Path 4841",
    d: "M406.051,114.225a13.57,13.57,0,0,0,4.775,3.592l-2.17,3.138-3.792-5.489Z",
    fill: "#eddad3"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_4842",
    "data-name": "Path 4842",
    d: "M410.826,117.817l1.7,2.578a3.527,3.527,0,0,1-3.434-.064Z",
    fill: "#5073ab"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_4843",
    "data-name": "Path 4843",
    d: "M432.626,120.88s-.016.058-.049.169c-.186.662-.9,3.207-1.832,6.59-.351.3-.711.6-1.076.888q-.619.489-1.263.947a30.485,30.485,0,0,1-13.945,5.4c.454-10.613,1.714-20.026,1.714-20.026q1.491.393,2.828.777l.007,0c7.78,2.233,11.726,4.193,13.071,4.937a.209.209,0,0,1,.03.015C432.462,120.774,432.626,120.88,432.626,120.88Z",
    fill: "#1f3138"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_4844",
    "data-name": "Path 4844",
    d: "M404.565,134.488a30.656,30.656,0,0,1-15.629-8.446c-.189-.19-.375-.383-.558-.577-.537-2.279-.893-3.767-.917-3.864v0s3.794-2.492,17.215-6.074v.008C404.675,115.837,404.683,124.447,404.565,134.488Z",
    fill: "#1f3138"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_4845",
    "data-name": "Path 4845",
    d: "M411.8,120.679c-.125,2.795-.138,8.219-.1,14.407-.334.011-.67.016-1.006.016q-1.49,0-2.941-.139a94.046,94.046,0,0,1,2.037-14.292c.149-.619.239-.928.239-.928l1.8.3C411.818,120.236,411.807,120.447,411.8,120.679Z",
    fill: "#5073ab"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group_5961",
    "data-name": "Group 5961"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_4846",
    "data-name": "Path 4846",
    d: "M434.172,124.165a30.888,30.888,0,0,1-3.427,3.474c-.351.3-.711.6-1.076.888l2.412-7.965v0c.01.007.02.012.029.019a2,2,0,0,1,.466.472A14.956,14.956,0,0,1,434.172,124.165Z",
    fill: "#1f3138"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_5962",
    "data-name": "Group 5962"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_4847",
    "data-name": "Path 4847",
    d: "M388.936,126.042c-.189-.19-.375-.383-.558-.577a29.713,29.713,0,0,1-1.946-2.278,3.552,3.552,0,0,1,1.028-1.591v0Z",
    fill: "#1f3138"
  })))), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_334",
    "data-name": "Rectangle 334",
    width: 41.307,
    height: 9.608,
    rx: 3.454,
    transform: "translate(187.71 62.563)",
    fill: "#f5f7ff"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group_5980",
    "data-name": "Group 5980"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_5967",
    "data-name": "Group 5967"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_5966",
    "data-name": "Group 5966"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_5965",
    "data-name": "Group 5965"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_4848",
    "data-name": "Path 4848",
    d: "M204.792,135.1a19.84,19.84,0,0,0,26.2-18.541c.006-.445,0-.89-.025-1.329a19.841,19.841,0,1,0-26.175,19.87Zm-8.512-18.987a14.877,14.877,0,0,1,28.858-4.889l0,.008a14.833,14.833,0,0,1,.867,4.267c.017.33.022.661.02,1a14.876,14.876,0,1,1-29.749-.383Z",
    fill: "#ff725e"
  })))), /*#__PURE__*/React.createElement("g", {
    id: "Group_5970",
    "data-name": "Group 5970"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_5969",
    "data-name": "Group 5969"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_5968",
    "data-name": "Group 5968"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_4849",
    "data-name": "Path 4849",
    d: "M222.916,125.41l3.926,3.04a19.869,19.869,0,0,1-22.051,6.649l1.593-4.7a14.9,14.9,0,0,0,16.532-4.985Z",
    fill: "#1a598c"
  })))), /*#__PURE__*/React.createElement("g", {
    id: "Group_5973",
    "data-name": "Group 5973"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_5972",
    "data-name": "Group 5972"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_5971",
    "data-name": "Group 5971"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_4850",
    "data-name": "Path 4850",
    d: "M226.008,115.5l4.959-.269c.023.439.032.884.025,1.33a19.746,19.746,0,0,1-4.15,11.893l-3.926-3.04a14.809,14.809,0,0,0,3.112-8.917Q226.034,115.99,226.008,115.5Z",
    fill: "#2273b5"
  })))), /*#__PURE__*/React.createElement("g", {
    id: "Group_5976",
    "data-name": "Group 5976"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_5975",
    "data-name": "Group 5975"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_5974",
    "data-name": "Group 5974"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_4851",
    "data-name": "Path 4851",
    d: "M226.009,115.5a14.833,14.833,0,0,0-.867-4.267l0-.008,4.668-1.7a19.731,19.731,0,0,1,1.161,5.7Z",
    fill: "#2273b5"
  })))), /*#__PURE__*/React.createElement("g", {
    id: "Group_5979",
    "data-name": "Group 5979"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_5978",
    "data-name": "Group 5978"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_5977",
    "data-name": "Group 5977"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_4852",
    "data-name": "Path 4852",
    d: "M199.22,100.452a19.844,19.844,0,0,1,30.586,9.074l-4.664,1.7,0-.008a14.874,14.874,0,0,0-23.007-6.744Z",
    fill: "#fc3622"
  }))))), /*#__PURE__*/React.createElement("g", {
    id: "Group_5985",
    "data-name": "Group 5985"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_5981",
    "data-name": "Group 5981"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Rectangle_335",
    "data-name": "Rectangle 335",
    d: "M4.624,0H17.477A4.625,4.625,0,0,1,22.1,4.625V17.477A4.624,4.624,0,0,1,17.477,22.1H4.625A4.625,4.625,0,0,1,0,17.476V4.624A4.624,4.624,0,0,1,4.624,0Z",
    transform: "translate(341.279 152.522)",
    fill: "#ff725e"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_5984",
    "data-name": "Group 5984"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_5983",
    "data-name": "Group 5983"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_5982",
    "data-name": "Group 5982"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_4853",
    "data-name": "Path 4853",
    d: "M351.63,168.441l-5.588-4.871a1.1,1.1,0,0,1,1.447-1.66l3.951,3.445,5.633-6.284a1.1,1.1,0,1,1,1.639,1.469Z",
    fill: "#f3f3f3"
  }))))), /*#__PURE__*/React.createElement("g", {
    id: "Group_5990",
    "data-name": "Group 5990"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_5986",
    "data-name": "Group 5986"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Rectangle_336",
    "data-name": "Rectangle 336",
    d: "M4.624,0H17.477A4.625,4.625,0,0,1,22.1,4.625V17.476A4.624,4.624,0,0,1,17.477,22.1H4.625A4.625,4.625,0,0,1,0,17.476V4.624A4.624,4.624,0,0,1,4.624,0Z",
    transform: "translate(341.279 180.844)",
    fill: "#ff725e"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_5989",
    "data-name": "Group 5989"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_5988",
    "data-name": "Group 5988"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_5987",
    "data-name": "Group 5987"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_4854",
    "data-name": "Path 4854",
    d: "M351.63,196.762l-5.588-4.871a1.1,1.1,0,0,1,1.447-1.659l3.951,3.444,5.633-6.284a1.1,1.1,0,1,1,1.639,1.47Z",
    fill: "#f3f3f3"
  }))))), /*#__PURE__*/React.createElement("g", {
    id: "Group_5992",
    "data-name": "Group 5992"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_5991",
    "data-name": "Group 5991"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_337",
    "data-name": "Rectangle 337",
    width: 22.102,
    height: 22.102,
    rx: 4.625,
    transform: "translate(341.279 209.165)",
    fill: "#ff725e"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Group_6009",
    "data-name": "Group 6009"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_5995",
    "data-name": "Group 5995"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_5994",
    "data-name": "Group 5994"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_5993",
    "data-name": "Group 5993"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_4855",
    "data-name": "Path 4855",
    d: "M271.26,362.139s.666,4.479,1.113,6.39,4.578,7.39,4.506,8.323-1.822,2.03-2.7,1.279-6.716-6.748-7.964-9.317-5.375-5.919-5.8-7.06,4.869-4.478,6.232-5.011S271.26,362.139,271.26,362.139Z",
    fill: "#263238"
  })))), /*#__PURE__*/React.createElement("path", {
    id: "Path_4856",
    "data-name": "Path 4856",
    d: "M260.914,282.436a16.588,16.588,0,0,0,.948,3.385,24.919,24.919,0,0,1,1.6,3.558c.11.373.777,3.056.89,3.395s-.65.869-1.172.152a22.431,22.431,0,0,1-1.125-2.742c-.231-.561-.943-2.333-1.135-2.01a21.006,21.006,0,0,0-.178,3.313,19.9,19.9,0,0,0,.54,3.27c.182.778,1.217,4.042.8,4.218s-.766.128-1.3-.748c0,0-.85.474-1.345-.6,0,0-.76.276-1.23-1.125a1.892,1.892,0,0,1-.75-.8,30.646,30.646,0,0,1-1.429-6.547c.011-1.75.422-2.97.347-4.206a32.877,32.877,0,0,0-.708-3.879Z",
    fill: "#eea886"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_4857",
    "data-name": "Path 4857",
    d: "M268.238,356.041l-1.59.7,4.612,5.4,1.528-1.691Z",
    fill: "#50558a"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_4858",
    "data-name": "Path 4858",
    d: "M284.356,367.347a16.987,16.987,0,0,1-1.892,3.455c-.866.981-4.18,2.734-4.2,5.647-.019,3.16,5.587,2.283,7.779,2.167s2.359-1.8,3.281-3.591,1.854-1.486,2.027-2.929a18.361,18.361,0,0,0-.707-4.671Z",
    fill: "#263238"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_4859",
    "data-name": "Path 4859",
    d: "M284.26,366.433l-.16,1.5a11.405,11.405,0,0,0,6.708.129l-.182-2.048Z",
    fill: "#50558a"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_4860",
    "data-name": "Path 4860",
    d: "M303.384,328.367c0-3.893-2.843-37.873-2.713-39.171.086-.846-.819-8.981-1.459-14.539-.005-.047-.011-.1-.016-.141,0-.012,0-.024,0-.034-.182-1.561-.339-2.908-.445-3.81l-.111-.947c-.021-.17-.031-.26-.031-.26s-18.339-3.616-27.847-.2c-.4.143-.778.3-1.142.466,0,0-.023.162-.065.465-.1.7-.293,2.169-.558,4.162-.045.336-.091.686-.141,1.05-1.353,10.246-.484,21.379,1.885,32.778,2.324,11.18,3.6,19.543,3.842,21.167.316,2.131,1.248,7.993,2.281,14.422-5.048,6.225-9.351,11.518-9.03,12.044.8,1.3,7.879,8.632,8.268,7.335,0,0,1.279-1.449,3.282-3.756.637,3.932,1.073,6.616,1.073,6.616s7.763,1.853,10.619.166c0,0-1.123-8.529-2.294-17.8C295.906,339.846,303.384,330.407,303.384,328.367Zm-17.213-2.812c-.1-5.229-2.423-34.529-2.177-34.529,1.145,0,7.592,27.9,7.831,31.83.05.8-.956,2.6-2.581,4.97-.731,1.067-1.588,2.246-2.53,3.5h0C286.392,328.459,286.185,326.347,286.171,325.555Z",
    fill: "#263238"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group_5996",
    "data-name": "Group 5996"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_4861",
    "data-name": "Path 4861",
    d: "M306.447,220.863l-4.932,17.692c-.169.573-.371,1.279-.586,2.1l-.008.032a.128.128,0,0,0-.006.021,69.557,69.557,0,0,0-2.144,13.3c-.206,3.641.469,18.278.469,18.278s-7.462,2.784-18.628,2.079c0,0-12.011-.28-11.032-7.644,2.592-19.49.057-27.527-.282-29.484,0,0-1.63-9.466-2.8-17.4,3.38-1.258,17.817-6.112,17.817-6.112l7.479.559S303.163,217.087,306.447,220.863Z",
    fill: "#f9e8de"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_5997",
    "data-name": "Group 5997"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_4862",
    "data-name": "Path 4862",
    d: "M288.07,188.718s7.3,1.231,6.062,12.66-7.682,10.421-8.114,10.4-6.481.138-6.8-13.836C279.218,197.947,279.125,187.615,288.07,188.718Z",
    fill: "#eea987"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_5998",
    "data-name": "Group 5998"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_4863",
    "data-name": "Path 4863",
    d: "M291.268,208.47s-.252,4.7.193,5.727-5.862,4.263-9.781.574c0,0,.793-5.142.547-6.958S291.268,208.47,291.268,208.47Z",
    fill: "#eea987"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_5999",
    "data-name": "Group 5999"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_4864",
    "data-name": "Path 4864",
    d: "M294.28,198.148s.81-.847,1.094.022-1.294,4.722-1.2,4.9c0,0-.15.335-.34.148A41.956,41.956,0,0,1,294.28,198.148Z",
    fill: "#eea987"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_6000",
    "data-name": "Group 6000"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_4865",
    "data-name": "Path 4865",
    d: "M279.3,197.84s-.775-.879-1.1-.022.848,4.7.993,4.94c0,0,.252.4.45.216A42.318,42.318,0,0,0,279.3,197.84Z",
    fill: "#eea987"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_6001",
    "data-name": "Group 6001"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_4866",
    "data-name": "Path 4866",
    d: "M294.747,197.176c-.252,1.564-.489,2.727-.489,2.727L293.2,201.29a27.88,27.88,0,0,0-.1-3.55c-.061-.182-.133-.506-.208-.856-.122-.578-.246-1.231-.332-1.448-.137-.347-6.257-2.135-11.708.374,0,0,.047.472.043,1,0,.613-.069,1.3-.35,1.4-.522.191-.3,3.59-.3,3.59l-.85-.98s-.246-1.776-.487-3.817l0-.015c-.055-.476-.111-.965-.164-1.451-.122-2.053.081-5.78,2.754-7.97,1.8-.773,4.684-1.429,9.485.041a3.3,3.3,0,0,1,1.41.371C295.372,191.27,294.747,197.176,294.747,197.176Z",
    fill: "#ff725e"
  })), /*#__PURE__*/React.createElement("path", {
    id: "Path_4867",
    "data-name": "Path 4867",
    d: "M282.728,210.255a4.649,4.649,0,0,0,3.872,1.557,5.268,5.268,0,0,0,3.882-1.472s-1.282,2.68-3.895,2.651S282.728,210.255,282.728,210.255Z",
    fill: "#c78d71"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_4868",
    "data-name": "Path 4868",
    d: "M280.936,214.869a7.95,7.95,0,0,0,5.669,3.727c2.355.2,4.393-2.78,5.348-4.246A14.262,14.262,0,0,0,280.936,214.869Z",
    fill: "#eea987"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_4869",
    "data-name": "Path 4869",
    d: "M291.277,213.273a20.257,20.257,0,0,1-4.672,4.048l1.977,3.045,3.371-6.016Z",
    fill: "#eddad3"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_4870",
    "data-name": "Path 4870",
    d: "M281.829,213.729a13.567,13.567,0,0,0,4.776,3.592l-2.17,3.137-3.794-5.489Z",
    fill: "#eddad3"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_4871",
    "data-name": "Path 4871",
    d: "M286.605,217.321,288.3,219.9a3.529,3.529,0,0,1-3.433-.065Z",
    fill: "#5073ab"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_4872",
    "data-name": "Path 4872",
    d: "M269.171,275.694s9.16,3.378,29.875.2l-.276-3.75s-12.007,3.543-29.233.509Z",
    fill: "#263238"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_4873",
    "data-name": "Path 4873",
    d: "M291.953,214.35a228.5,228.5,0,0,0-1.848,29.8c.294,13.8,10.717,38.862,10.717,38.862s4.556-4.406,6.54-6.9c0,0-7.094-20.467-6.963-24.16s8.005-31.568,8.005-31.568S304.028,217.529,291.953,214.35Z",
    fill: "#1f3138"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_4874",
    "data-name": "Path 4874",
    d: "M280.454,215.026s.017,15.324-.277,29.124-2.11,39.492-2.11,39.492-10.2-1.615-12.185-4.111c0,0,4.132-23.887,4-27.58s-6.646-30.85-6.646-30.85S267.031,218.607,280.454,215.026Z",
    fill: "#1f3138"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_338",
    "data-name": "Rectangle 338",
    width: 5.627,
    height: 4.185,
    transform: "translate(281.664 273.294)",
    fill: "#3a4066"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_4875",
    "data-name": "Path 4875",
    d: "M285.81,219.246s-2.514,8.579-2.734,25.619.31,21.925.31,21.925l1.961,3.883,2.615-4.052s-.838-39.209-.353-47.076Z",
    fill: "#5073ab"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group_6006",
    "data-name": "Group 6006"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_6005",
    "data-name": "Group 6005"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_6004",
    "data-name": "Group 6004"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_6003",
    "data-name": "Group 6003"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_6002",
    "data-name": "Group 6002"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_4876",
    "data-name": "Path 4876",
    d: "M300.255,283.156a3.374,3.374,0,0,0,.783-.7s.26-.551.473-.934a2.725,2.725,0,0,1,.178-.288,5.525,5.525,0,0,0,1.013-1.557,32.562,32.562,0,0,0,.511-4.275l-2.159-.634-1.921-.845s-4.2,3.224-4.558,3.9a1.8,1.8,0,0,0-.088.2,6.227,6.227,0,0,0-.2,1.455c-.029.119-.227,1.329.057,1.6a1.473,1.473,0,0,0,1.235.434,3.382,3.382,0,0,0,1.573.762,2.188,2.188,0,0,0,1.7.508S299.67,283.383,300.255,283.156Z",
    fill: "#eea886"
  })))))), /*#__PURE__*/React.createElement("g", {
    id: "Group_6007",
    "data-name": "Group 6007"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_4877",
    "data-name": "Path 4877",
    d: "M297.5,273.533a22.661,22.661,0,0,0,7.008,3.946s13.556-22.09,13.727-23.683c.158-1.475-6.726-31.513-9.832-33.413l-5.642,16.52c.374-.11,6.421,12.548,6.444,14.176C309.24,253.262,297.5,273.533,297.5,273.533Z",
    fill: "#1f3138"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_6008",
    "data-name": "Group 6008"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_4878",
    "data-name": "Path 4878",
    d: "M262.51,285.424a34.366,34.366,0,0,1-7.453.317s1.717-28.353,1.546-29.948c-.158-1.474,3.531-32.791,6.636-34.692l5.541,16.692c-.374-.109-3.714,17.075-3.738,18.7C265.01,258.679,262.51,285.424,262.51,285.424Z",
    fill: "#1f3138"
  })), /*#__PURE__*/React.createElement("path", {
    id: "Path_4879",
    "data-name": "Path 4879",
    d: "M293.953,276.672l8.71,4.518-3.424,6.339-7.414-7.927Z",
    fill: "#263238"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_4880",
    "data-name": "Path 4880",
    d: "M289.244,327.826l-.88,17.239-1.65-13.735h0C287.656,330.072,288.513,328.893,289.244,327.826Z",
    fill: "#263238"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_6010",
    "data-name": "Group 6010"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_339",
    "data-name": "Rectangle 339",
    width: 5.084,
    height: 16.67,
    transform: "translate(245.403 118.292)",
    fill: "#ff725e"
  })), /*#__PURE__*/React.createElement("path", {
    id: "Path_4881",
    "data-name": "Path 4881",
    d: "M432.653,229.348a23.565,23.565,0,1,1-23.565-23.566A23.566,23.566,0,0,1,432.653,229.348Z",
    fill: "#eef0f7"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group_6011",
    "data-name": "Group 6011"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_340",
    "data-name": "Rectangle 340",
    width: 5.084,
    height: 11.995,
    transform: "translate(237.069 122.968)",
    fill: "#ff725e"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_6012",
    "data-name": "Group 6012"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_341",
    "data-name": "Rectangle 341",
    width: 5.084,
    height: 24.396,
    transform: "translate(253.736 110.566)",
    fill: "#ff725e"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_6101",
    "data-name": "Group 6101"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_6013",
    "data-name": "Group 6013"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_342",
    "data-name": "Rectangle 342",
    width: 32.701,
    height: 1.941,
    transform: "translate(498.256 298.824) rotate(180)",
    fill: "#e2d2ca"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_6014",
    "data-name": "Group 6014"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_343",
    "data-name": "Rectangle 343",
    width: 2.865,
    height: 88.28,
    transform: "translate(491.008 303.876)",
    fill: "#706865"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_6015",
    "data-name": "Group 6015"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_344",
    "data-name": "Rectangle 344",
    width: 22.73,
    height: 2.772,
    transform: "translate(470.673 299.106) rotate(180)",
    fill: "#ff725e"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_6016",
    "data-name": "Group 6016"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_345",
    "data-name": "Rectangle 345",
    width: 8.607,
    height: 26.145,
    transform: "translate(463.612 298.824) rotate(180)",
    fill: "#4667a8"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_6017",
    "data-name": "Group 6017"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_346",
    "data-name": "Rectangle 346",
    width: 125.939,
    height: 5.019,
    transform: "translate(509.987 303.876) rotate(180)",
    fill: "#b59074"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_6018",
    "data-name": "Group 6018"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_4882",
    "data-name": "Path 4882",
    d: "M534.157,268.475s1.377,19.317-2.4,21.629c-2.364,1.448-11.791,6.332-11.512,7.248s5.324,8.15,5.324,8.15,18.107-11.924,18.691-15.681c.57-3.671-.892-28.284-3.38-29.417-1.864-.85-2.849-.147-5.2,1.6C532.388,264.449,534.157,268.475,534.157,268.475Z",
    fill: "#263238"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_6021",
    "data-name": "Group 6021"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_6020",
    "data-name": "Group 6020"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_6019",
    "data-name": "Group 6019"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_4883",
    "data-name": "Path 4883",
    d: "M511.878,380.1s.563,3.908.634,4.495,6.264-.346,6.264-.346l.5-4.653S512.653,379.552,511.878,380.1Z",
    fill: "#424773"
  })))), /*#__PURE__*/React.createElement("g", {
    id: "Group_6024",
    "data-name": "Group 6024"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_6023",
    "data-name": "Group 6023"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_6022",
    "data-name": "Group 6022"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_4884",
    "data-name": "Path 4884",
    d: "M512.447,384.1a16.731,16.731,0,0,1-3.862,3.382c-1.9,1.026-4.88,1.433-6,2.5-.809.766-2.95,4.068,4.933,4s11.683.465,12.527-.8-1.221-9.345-1.221-9.345S516.953,384.509,512.447,384.1Z",
    fill: "#263238"
  })))), /*#__PURE__*/React.createElement("g", {
    id: "Group_6027",
    "data-name": "Group 6027"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_6026",
    "data-name": "Group 6026"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_6025",
    "data-name": "Group 6025"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_4885",
    "data-name": "Path 4885",
    d: "M472.2,380.141s.562,3.908.632,4.494,6.264-.346,6.264-.346l.5-4.652S472.972,379.589,472.2,380.141Z",
    fill: "#424773"
  })))), /*#__PURE__*/React.createElement("g", {
    id: "Group_6030",
    "data-name": "Group 6030"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_6029",
    "data-name": "Group 6029"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_6028",
    "data-name": "Group 6028"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_4886",
    "data-name": "Path 4886",
    d: "M472.765,384.139a16.741,16.741,0,0,1-3.861,3.382c-1.9,1.026-8.882,1.87-10,2.932-.81.766-2.158,3.855,8.933,3.566,7.88-.205,11.684.466,12.528-.8s-1.222-9.345-1.222-9.345S477.38,384.592,472.765,384.139Z",
    fill: "#263238"
  })))), /*#__PURE__*/React.createElement("g", {
    id: "Group_6033",
    "data-name": "Group 6033"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_6032",
    "data-name": "Group 6032"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_6031",
    "data-name": "Group 6031"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_4887",
    "data-name": "Path 4887",
    d: "M531.855,312.59s-22.518,3.81-27.6,4.607-32.662,7.662-36.11,9.752c-2.745,1.664,1.439,41.638,2.417,56.888H481.42l.788-45.747c13.034.326,22.335-3.049,31.826-1.607s17.4,3.49,23.435-4.6C537.469,331.883,537.693,314.356,531.855,312.59Z",
    fill: "#263238"
  })))), /*#__PURE__*/React.createElement("g", {
    id: "Group_6036",
    "data-name": "Group 6036"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_6035",
    "data-name": "Group 6035"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_6034",
    "data-name": "Group 6034"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_4888",
    "data-name": "Path 4888",
    d: "M509.66,383.874l10.585-.655,1.032-45.129a64.334,64.334,0,0,0,12.076-.766l8.545-19.865c-7.49,1.5-31.487,7.55-34.687,9.49C504.466,328.614,508.683,368.623,509.66,383.874Z",
    fill: "#263238"
  })))), /*#__PURE__*/React.createElement("g", {
    id: "Group_6039",
    "data-name": "Group 6039"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_6038",
    "data-name": "Group 6038"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_6037",
    "data-name": "Group 6037"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_4889",
    "data-name": "Path 4889",
    d: "M521.49,228.186s-8.254-2.282-11.4,4.127-1.72,18.555,2.44,19.7,10.141-.173,11.869-4.161,3.1-9.655,2.691-13.325S523.682,229.063,521.49,228.186Z",
    fill: "#eea886"
  })))), /*#__PURE__*/React.createElement("g", {
    id: "Group_6042",
    "data-name": "Group 6042"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_6041",
    "data-name": "Group 6041"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_6040",
    "data-name": "Group 6040"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_4890",
    "data-name": "Path 4890",
    d: "M514.681,250.733s.091,4.873-.446,5.912,11.494.777,11.494.777-1.9-5.851-.821-10.837C525.973,241.651,514.681,250.733,514.681,250.733Z",
    fill: "#eea886"
  })))), /*#__PURE__*/React.createElement("g", {
    id: "Group_6045",
    "data-name": "Group 6045"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_6044",
    "data-name": "Group 6044"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_6043",
    "data-name": "Group 6043"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_4891",
    "data-name": "Path 4891",
    d: "M525.556,244.74s-.643,1.307-3.757,1.1-7.222-3.968-8.543-4.3-1.4-1.087-1.4-1.087l-.7,1.243-1.355.207s.92-3.766-1.086-5.092.9-12,11.059-9.429c0,0,7.75,1.419,7.853,5.747S527.061,242.447,525.556,244.74Z",
    fill: "#3a3f47"
  })))), /*#__PURE__*/React.createElement("g", {
    id: "Group_6048",
    "data-name": "Group 6048"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_6047",
    "data-name": "Group 6047"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_6046",
    "data-name": "Group 6046"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_4892",
    "data-name": "Path 4892",
    d: "M513.6,256.52s.034-1.986.933-2.176,9.458-1.367,10.562-.934l.475,2.621S523.444,257.342,513.6,256.52Z",
    fill: "#e2d2ca"
  })))), /*#__PURE__*/React.createElement("g", {
    id: "Group_6051",
    "data-name": "Group 6051"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_6050",
    "data-name": "Group 6050"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_6049",
    "data-name": "Group 6049"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_4893",
    "data-name": "Path 4893",
    d: "M511.126,239.557c.231-1.627,2.08-3.5,3.14-.961s-.715,6.225-1.9,6.026S510.813,241.764,511.126,239.557Z",
    fill: "#eea886"
  })))), /*#__PURE__*/React.createElement("g", {
    id: "Group_6054",
    "data-name": "Group 6054"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_6053",
    "data-name": "Group 6053"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_6052",
    "data-name": "Group 6052"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_4894",
    "data-name": "Path 4894",
    d: "M477.758,279.973a.025.025,0,0,1,.015,0C477.711,280,477.7,280,477.758,279.973Z",
    fill: "#1f3138"
  })))), /*#__PURE__*/React.createElement("g", {
    id: "Group_6057",
    "data-name": "Group 6057"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_6056",
    "data-name": "Group 6056"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_6055",
    "data-name": "Group 6055"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_4895",
    "data-name": "Path 4895",
    d: "M523.9,229.348s10.064-.474,1.757,15.237Z",
    fill: "#3a3f47"
  })))), /*#__PURE__*/React.createElement("g", {
    id: "Group_6059",
    "data-name": "Group 6059"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_6058",
    "data-name": "Group 6058"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_4896",
    "data-name": "Path 4896",
    d: "M546.322,389.227l-.749,2.107-31.634-9.8,1.517-4.266Z",
    fill: "#918783"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Group_6061",
    "data-name": "Group 6061"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_6060",
    "data-name": "Group 6060"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_347",
    "data-name": "Rectangle 347",
    width: 3.596,
    height: 34.393,
    transform: "translate(516.449 380.031) rotate(180)",
    fill: "#918783"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Group_6063",
    "data-name": "Group 6063"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_6062",
    "data-name": "Group 6062"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_348",
    "data-name": "Rectangle 348",
    width: 21.207,
    height: 2.027,
    transform: "translate(525.255 345.838) rotate(180)",
    fill: "#5e5854"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Group_6065",
    "data-name": "Group 6065"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_6064",
    "data-name": "Group 6064"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_4897",
    "data-name": "Path 4897",
    d: "M482.7,389.227l.749,2.107,31.634-9.8L513.7,377Z",
    fill: "#918783"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Group_6067",
    "data-name": "Group 6067"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_6066",
    "data-name": "Group 6066"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_4898",
    "data-name": "Path 4898",
    d: "M504.992,391.109v2.449l10.094-12.025L513.7,377Z",
    fill: "#918783"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Group_6069",
    "data-name": "Group 6069"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_6068",
    "data-name": "Group 6068"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_4899",
    "data-name": "Path 4899",
    d: "M479.747,392.156A2.956,2.956,0,1,0,482.7,389.2,2.958,2.958,0,0,0,479.747,392.156Z",
    fill: "#bfb2ac"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Group_6071",
    "data-name": "Group 6071"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_6070",
    "data-name": "Group 6070"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_4900",
    "data-name": "Path 4900",
    d: "M504.74,392.156A2.957,2.957,0,1,0,507.7,389.2,2.958,2.958,0,0,0,504.74,392.156Z",
    fill: "#bfb2ac"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Group_6073",
    "data-name": "Group 6073"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_6072",
    "data-name": "Group 6072"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_4901",
    "data-name": "Path 4901",
    d: "M543.365,392.156a2.957,2.957,0,1,0,2.957-2.956A2.957,2.957,0,0,0,543.365,392.156Z",
    fill: "#bfb2ac"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Group_6074",
    "data-name": "Group 6074"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_349",
    "data-name": "Rectangle 349",
    width: 50.239,
    height: 7.676,
    rx: 3.789,
    transform: "translate(539.632 343.811) rotate(180)",
    fill: "#e2d2ca"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_6075",
    "data-name": "Group 6075"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_350",
    "data-name": "Rectangle 350",
    width: 2.864,
    height: 88.28,
    transform: "translate(403.025 392.156) rotate(180)",
    fill: "#706865"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_6076",
    "data-name": "Group 6076"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Rectangle_351",
    "data-name": "Rectangle 351",
    d: "M3.781,0H70.545a3.78,3.78,0,0,1,3.78,3.78V48.652a3.78,3.78,0,0,1-3.78,3.78H3.781A3.781,3.781,0,0,1,0,48.651V3.781A3.781,3.781,0,0,1,3.781,0Z",
    transform: "translate(496.47 285.275) rotate(180)",
    fill: "#5f8be3"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_6077",
    "data-name": "Group 6077"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_352",
    "data-name": "Rectangle 352",
    width: 68.504,
    height: 41.382,
    transform: "translate(493.56 277.058) rotate(180)",
    fill: "#f5f7ff"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_6078",
    "data-name": "Group 6078"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_353",
    "data-name": "Rectangle 353",
    width: 68.504,
    height: 3.293,
    transform: "translate(493.56 238.969) rotate(180)",
    fill: "#cecfd6"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_6079",
    "data-name": "Group 6079"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Rectangle_354",
    "data-name": "Rectangle 354",
    d: "M2.339,0h3.58a2.34,2.34,0,0,1,2.34,2.34V30.723a2.34,2.34,0,0,1-2.34,2.34H2.339A2.339,2.339,0,0,1,0,30.724V2.339A2.339,2.339,0,0,1,2.339,0Z",
    transform: "translate(435.848 274.509) rotate(180)",
    fill: "#cecfd6"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_6080",
    "data-name": "Group 6080"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Rectangle_355",
    "data-name": "Rectangle 355",
    d: "M1.263,0H13.8a1.264,1.264,0,0,1,1.264,1.264V1.8A1.264,1.264,0,0,1,13.8,3.063H1.264A1.264,1.264,0,0,1,0,1.8V1.263A1.263,1.263,0,0,1,1.263,0Z",
    transform: "translate(491.622 244.509) rotate(180)",
    fill: "#cecfd6"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_6081",
    "data-name": "Group 6081"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Rectangle_356",
    "data-name": "Rectangle 356",
    d: "M2.609,0h9.847a2.61,2.61,0,0,1,2.61,2.61V26.182a2.609,2.609,0,0,1-2.609,2.609H2.609A2.609,2.609,0,0,1,0,26.182V2.609A2.609,2.609,0,0,1,2.609,0Z",
    transform: "translate(491.622 275.354) rotate(180)",
    fill: "#cecfd6"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_6082",
    "data-name": "Group 6082"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_4902",
    "data-name": "Path 4902",
    d: "M456.91,280.922a2.4,2.4,0,1,0,2.4-2.4A2.4,2.4,0,0,0,456.91,280.922Z",
    fill: "#5c5552"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_6083",
    "data-name": "Group 6083"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_4903",
    "data-name": "Path 4903",
    d: "M443.921,298.924v-.933s1.312-5.8,10.59-5.8,9.091,6.736,9.091,6.736Z",
    fill: "#2e436e"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_6085",
    "data-name": "Group 6085"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_6084",
    "data-name": "Group 6084"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_4904",
    "data-name": "Path 4904",
    d: "M463.715,293.05a9.148,9.148,0,0,1-2.755-.6c-.738-.445-5.157-3.417-6.194-2.941s-7.944,2.592-7.7,3.6.879.912,1.366.733,5.5-1.231,5.945-1.054c0,0-4.925,1.8-4.945,3.109s1.03,1.63,1.5,2.126,1.028,1.727,2.3,1.821,7.464-2.06,8.738-2.158,3.636.079,3.8-.129S463.715,293.05,463.715,293.05Z",
    fill: "#eea886"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Group_6088",
    "data-name": "Group 6088"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_6087",
    "data-name": "Group 6087"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_6086",
    "data-name": "Group 6086"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_4905",
    "data-name": "Path 4905",
    d: "M500.41,259.271c6.427-1.13,13.192-2.751,13.192-2.751l11.97-.489s10.985,2.418,15.311,4.373c.41.185.412,9.8,1.538,12.321l-3.586,7.567s-2.073,14.989-2.5,21.655c-.2,3.061.559,29.578.559,29.578s-1.075.53-9.244,1.43-28.579-.325-28.708-1.289,3.952-35.928,4.134-37.738c.276-2.778-.8-15.619-.8-15.619-1.538,2.067-5.462,11.4-9.553,15.845-2.4,2.614-14.318,4.216-16.563,4.292-4.888.163-13.805,1.135-14.066.66-.207-.285-.776-7.914-.218-8.1.491-.163,17.047-1.116,21.289-3.367,1.552-.823,6.191-10.94,6.191-10.94S496.865,260.863,500.41,259.271Z",
    fill: "#263238"
  })))), /*#__PURE__*/React.createElement("g", {
    id: "Group_6089",
    "data-name": "Group 6089"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_357",
    "data-name": "Rectangle 357",
    width: 34.646,
    height: 47.985,
    rx: 7.276,
    transform: "translate(551.369 330.759) rotate(180)",
    fill: "#e2d2ca"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_6090",
    "data-name": "Group 6090"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_4906",
    "data-name": "Path 4906",
    d: "M522.862,341.9c5.107,0,9.25-1.715,12.315-5.1,6.926-7.647,5.681-21.089,5.625-21.657a1.928,1.928,0,0,0-3.837.38c.016.153,1.119,12.337-4.653,18.7-2.334,2.573-5.426,3.824-9.45,3.824a1.928,1.928,0,1,0,0,3.855Z",
    fill: "#e2d2ca"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_6100",
    "data-name": "Group 6100"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_4907",
    "data-name": "Path 4907",
    d: "M460.3,252.59a9.655,9.655,0,0,1-3.35,7.32c-.11.1-.223.191-.338.282q-.2.153-.4.3a9.62,9.62,0,0,1-4.4,1.7q-.43.053-.871.067c-.106,0-.211.005-.318.005-.313,0-.623-.016-.928-.044a9.531,9.531,0,0,1-1.007-.15,9.63,9.63,0,0,1-3.955-1.8,9.506,9.506,0,0,1-.976-.861c-.06-.058-.119-.12-.176-.181a9.335,9.335,0,0,1-.615-.719A9.676,9.676,0,1,1,460.3,252.59Z",
    fill: "#eef0f7"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group_6099",
    "data-name": "Group 6099"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_6091",
    "data-name": "Group 6091"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_4908",
    "data-name": "Path 4908",
    d: "M456.928,257.929l-.713,2.561a9.62,9.62,0,0,1-4.4,1.7q-.43.053-.871.067c-.106,0-.211.005-.318.005-.313,0-.623-.016-.928-.044a9.531,9.531,0,0,1-1.007-.15,9.63,9.63,0,0,1-3.955-1.8c-.137-.846-.284-1.783-.413-2.659.711-.266,2.975-1.036,4.4-1.518.019-.007.039-.014.058-.019l.093-.033c.085-.028.166-.055.242-.082l.223-.075.572-.192h0l.03-.01h.015l1.921.143.322.025.1.008.044.01c.115.031.452.119.9.254h0A9.415,9.415,0,0,1,456.928,257.929Z",
    fill: "#f9e8de"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_6092",
    "data-name": "Group 6092"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_4909",
    "data-name": "Path 4909",
    d: "M451.13,247.785s2.3.39,1.912,4-2.424,3.288-2.56,3.284-2.045.043-2.146-4.368C448.336,250.7,448.307,247.438,451.13,247.785Z",
    fill: "#eea987"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_6093",
    "data-name": "Group 6093"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_4910",
    "data-name": "Path 4910",
    d: "M452.139,254.019a8.367,8.367,0,0,0,.06,1.807c.141.324-1.849,1.345-3.085.181a12.656,12.656,0,0,0,.171-2.195C449.208,253.238,452.139,254.019,452.139,254.019Z",
    fill: "#eea987"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_6094",
    "data-name": "Group 6094"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_4911",
    "data-name": "Path 4911",
    d: "M453.089,250.762s.256-.268.346.007-.408,1.49-.378,1.545c0,0-.047.105-.107.046A13.222,13.222,0,0,1,453.089,250.762Z",
    fill: "#eea987"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_6095",
    "data-name": "Group 6095"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_4912",
    "data-name": "Path 4912",
    d: "M448.363,250.664s-.245-.277-.345-.007a4.615,4.615,0,0,0,.313,1.559s.079.125.142.068A13.389,13.389,0,0,0,448.363,250.664Z",
    fill: "#eea987"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_6096",
    "data-name": "Group 6096"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_4913",
    "data-name": "Path 4913",
    d: "M453.237,250.455c-.081.493-.155.86-.155.86l-.335.438a8.7,8.7,0,0,0-.032-1.12c-.018-.058-.042-.16-.065-.27a4.6,4.6,0,0,0-.1-.458,4.94,4.94,0,0,0-3.694.119s.014.149.014.315c0,.193-.023.409-.112.442-.164.061-.1,1.133-.1,1.133l-.267-.309s-.078-.56-.154-1.2V250.4c-.018-.151-.036-.3-.053-.458a3.016,3.016,0,0,1,.869-2.516,4.157,4.157,0,0,1,2.993.014,1.025,1.025,0,0,1,.445.117A4.275,4.275,0,0,1,453.237,250.455Z",
    fill: "#ff725e"
  })), /*#__PURE__*/React.createElement("path", {
    id: "Path_4914",
    "data-name": "Path 4914",
    d: "M449.444,254.582a1.468,1.468,0,0,0,1.221.491,1.664,1.664,0,0,0,1.226-.464,1.493,1.493,0,0,1-1.23.837A1.51,1.51,0,0,1,449.444,254.582Z",
    fill: "#c78d71"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_4915",
    "data-name": "Path 4915",
    d: "M448.878,256.038a2.507,2.507,0,0,0,1.789,1.176c.743.065,1.387-.877,1.689-1.34A4.505,4.505,0,0,0,448.878,256.038Z",
    fill: "#eea987"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_4916",
    "data-name": "Path 4916",
    d: "M452.141,255.534a6.406,6.406,0,0,1-1.474,1.278l.624.961,1.065-1.9Z",
    fill: "#eddad3"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_4917",
    "data-name": "Path 4917",
    d: "M449.16,255.678a4.3,4.3,0,0,0,1.507,1.134l-.684.99-1.2-1.732Z",
    fill: "#eddad3"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_4918",
    "data-name": "Path 4918",
    d: "M450.667,256.812l.535.813a1.113,1.113,0,0,1-1.084-.02Z",
    fill: "#5073ab"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_4919",
    "data-name": "Path 4919",
    d: "M457.546,257.779c-.009.032-.584,2.1-.594,2.131-.11.1-.223.191-.338.282q-.2.153-.4.3a9.62,9.62,0,0,1-4.4,1.7c.142-3.35.541-6.32.541-6.32q.47.123.891.245h0A21.557,21.557,0,0,1,457.546,257.779Z",
    fill: "#1f3138"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_4920",
    "data-name": "Path 4920",
    d: "M448.691,262.072a9.63,9.63,0,0,1-3.955-1.8,9.506,9.506,0,0,1-.976-.861c-.06-.058-.119-.12-.176-.181-.17-.719-.282-1.189-.29-1.219v0s1.2-.787,5.433-1.917v0C448.727,256.187,448.729,258.9,448.691,262.072Z",
    fill: "#1f3138"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_4921",
    "data-name": "Path 4921",
    d: "M450.974,257.715c-.039.881-.043,2.593-.03,4.546-.106,0-.211.005-.318.005-.313,0-.623-.016-.928-.044a29.786,29.786,0,0,1,.643-4.51c.047-.2.075-.293.075-.293l.569.094C450.981,257.574,450.977,257.642,450.974,257.715Z",
    fill: "#5073ab"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group_6097",
    "data-name": "Group 6097"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_4922",
    "data-name": "Path 4922",
    d: "M458.034,258.815a9.728,9.728,0,0,1-1.082,1.1c-.11.1-.223.191-.338.282l.932-2.413C457.789,257.917,457.928,258.558,458.034,258.815Z",
    fill: "#1f3138"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_6098",
    "data-name": "Group 6098"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_4923",
    "data-name": "Path 4923",
    d: "M443.76,259.406c-.06-.058-.119-.12-.176-.181a9.335,9.335,0,0,1-.615-.719,1.116,1.116,0,0,1,.325-.5v0Z",
    fill: "#1f3138"
  }))))), /*#__PURE__*/React.createElement("g", {
    id: "Group_6102",
    "data-name": "Group 6102"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_4924",
    "data-name": "Path 4924",
    d: "M409.087,238.742a1.186,1.186,0,0,1-1.186-1.187V221.138a1.187,1.187,0,1,1,2.374,0v16.417A1.187,1.187,0,0,1,409.087,238.742Z",
    fill: "#949494"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_6103",
    "data-name": "Group 6103"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_4925",
    "data-name": "Path 4925",
    d: "M417.3,230.533H400.879a1.187,1.187,0,0,1,0-2.374H417.3a1.187,1.187,0,1,1,0,2.374Z",
    fill: "#949494"
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgAboutHero);
export default __webpack_public_path__ + "static/media/about-hero.c04b4075f3a3fbc034d8ada3ff8b82d2.svg";
export { ForwardRef as ReactComponent };